module.exports = __webpack_public_path__ + "img/Colouring_stock.74b8f4da.svg";